import React, {useState, useEffect, useContext} from 'react';
import {Platform} from 'react-native';
import RequestIDForm from '../../components/modules/RequestIdForm';
import {
  isEmpty,
  trimSpace,
  validateEmail,
  validName,
} from '../../utils/HelperMethods';
import {fetchApi} from '../../utils/ApiHelper';
import Button from '../../components/elements/Button';
import Popup from '../../components/elements/Popup';
import BottomExpandableDrawer from '../../components/modules/BottomExpandableDrawer';
import {BUTTON_TYPES} from '../../utils/Constants';
import {HTTP_METHODS, REQUEST_EMP_ID} from '../../utils/URLConstants';
import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../theme';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';
import {errorStatusContext} from '../../contexts/ErrorStatusContext';
import {tID} from '../../utils/TestIdHelper';
import UI from './ui';
import {RequestFailedIcon} from '../../utils/SvgIcons';

export const RequestSuccessPopup = ({modalVisible, fetchDate, ...props}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <Popup
      testID={tID('RequestUniqueId-Modal-Popup')}
      title={'Unique ID Requested'}
      visible={modalVisible}
      description={
        'If applicable, you will receive an email with your Employer Unique ID within 2 business days.'
      }
      {...props}>
      <Button
        testID={tID('RequestUniqueId-Button-Continue')}
        style={styles.continueButton}
        onPress={fetchDate}
        title={'Continue'}
        buttonType={BUTTON_TYPES.Filled}
        titleColor={colors.textOnAccent}
      />
    </Popup>
  );
};

export const BottomErrorDrawer = ({
  bottomModalVisible,
  onPressMySetttings,
  ...props
}) => {
  const {colors} = useTheme();
  return (
    <BottomExpandableDrawer
      testID={tID('RequestUniqueId-Modal-BottomExpandableDrawer')}
      title={'Request Failed'}
      rippleColor={colors.dangerMuted}
      visible={bottomModalVisible}
      showRipple={bottomModalVisible}
      subtitle={'Your submission failed to send. Please try again.'}
      rippleIcon={<RequestFailedIcon />}
      buttons={[
        {
          title: 'Close',
          buttonType: BUTTON_TYPES.Bordered,
          onPress: onPressMySetttings,
        },
      ]}
      {...props}
    />
  );
};

export const RequestButton = ({
  employerName,
  firstName,
  email,
  lastName,
  requestEmployerId,
  ...props
}) => {
  const {colors} = useTheme();
  return (
    <Button
      testID={tID('RequestUniqueId-Button-Request')}
      disabled={!Boolean(employerName && firstName && email && lastName)}
      buttonType={BUTTON_TYPES.Filled}
      titleColor={colors.textOnAccent}
      title={'Request Unique ID'}
      onPress={requestEmployerId}
      {...props}
    />
  );
};

const RequestUniqueId = ({navigation}) => {
  const [employerName, setEmployerName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [emailhasError, setEmailhasError] = useState(true);
  const [firstHasError, setFirstHasError] = useState(false);
  const [lastHasError, setLastHasError] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [bottomModalVisible, setBottomModalVisible] = useState(false);

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);

  useEffect(() => {
    let delayDebounceFn = setTimeout(() => {
      if (email) {
        const ValidationFlag = validateEmail(email);
        setEmailhasError(ValidationFlag ? true : false);
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [email]);

  useEffect(() => {
    if (!validName(firstName) && !isEmpty(firstName)) {
      if (!firstHasError) {
        setFirstHasError(true);
      }
    } else {
      if (firstHasError) {
        setFirstHasError(false);
      }
    }
    if (!validName(lastName) && !isEmpty(lastName)) {
      if (!lastHasError) {
        setLastHasError(true);
      }
    } else {
      if (lastHasError) {
        setLastHasError(false);
      }
    }
  }, [firstName, lastName, firstHasError, lastHasError]);

  //Un-used method, will delete after review from Sarvanan
  // const requestUniqueId = () => {
  //   setModalVisible(!modalVisible);
  // };

  const onPressMySetttings = () => {
    setBottomModalVisible(!bottomModalVisible);
  };
  const fetchDate = () => {
    //setBottomModalVisible(!bottomModalVisible);
    setModalVisible(false);
    if ((Platform.OS = 'web')) {
      navigation('/login', {replace: true});
    } else {
      navigation.navigate('OnBoardingExperience');
    }
  };

  const requestEmployerId = () => {
    //will also disable the button once we have that functionality in button

    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.POST, REQUEST_EMP_ID, {
      employerName: trimSpace(employerName),
      firstname: trimSpace(firstName),
      lastname: trimSpace(lastName),
      email: trimSpace(email),
    })
      .then(response => response.data)
      .then(data => {
        lpc.setVisible(false);
        if (data.status == 'success') {
          setTimeout(() => {
            setModalVisible(true);
          }, 1000);
        } else {
          setTimeout(() => {
            setBottomModalVisible(true);
          }, 1000);
        }
      })
      .catch(error => {
        lpc.setVisible(false);
        //possibly save error in analytics too
        setTimeout(() => {
          setBottomModalVisible(true);
        }, 1000);
      });
  };

  const uiProps = {
    navigation,
    fetchDate,
    modalVisible,
    bottomModalVisible,
    onPressMySetttings,
    employerName,
    firstName,
    lastName,
    email,
    requestEmployerId,
  };

  return (
    <UI {...uiProps}>
      <RequestIDForm
        hasError={!emailhasError}
        firstHasError={firstHasError}
        lastHasError={lastHasError}
        errorText="Please enter a valid email address."
        employerName={employerName}
        firstName={firstName}
        lastName={lastName}
        email={email}
        onChangeEmployer={setEmployerName}
        onChangeFirstName={setFirstName}
        onChangeLastName={setLastName}
        onChangeEmail={setEmail}
      />
    </UI>
  );
};

export default RequestUniqueId;
